import DepositsService from '../../services/DepositsService';
import swal from "sweetalert";

// Action Types
export const DEPOSITS_LOADING_TOGGLE = '[Deposits] Loading Toggle';
export const GET_DEPOSITS_SUCCESS = '[Deposits] Get Deposits Success';
export const GET_DEPOSITS_FAILED = '[Deposits] Get Deposits Failed';
export const GET_DEPOSIT_BY_ID_SUCCESS = '[Deposits] Get Deposit By ID Success';
export const GET_DEPOSIT_BY_ID_FAILED = '[Deposits] Get Deposit By ID Failed';
export const CREATE_DEPOSIT_SUCCESS = '[Deposits] Create Deposit Success';
export const CREATE_DEPOSIT_FAILED = '[Deposits] Create Deposit Failed';
export const UPDATE_DEPOSIT_SUCCESS = '[Deposits] Update Deposit Success';
export const UPDATE_DEPOSIT_FAILED = '[Deposits] Update Deposit Failed';
export const CLOSE_DEPOSIT_SUCCESS = '[Deposits] Close Deposit Success';
export const CLOSE_DEPOSIT_FAILED = '[Deposits] Close Deposit Failed';
export const GET_DEPOSIT_HISTORY_SUCCESS = '[Deposits] Get Deposit History Success';
export const GET_DEPOSIT_HISTORY_FAILED = '[Deposits] Get Deposit History Failed';
export const GET_DEPOSITS_DROPDOWN_SUCCESS = '[Deposits] Get Deposits Dropdown Success';
export const GET_DEPOSITS_DROPDOWN_FAILED = '[Deposits] Get Deposits Dropdown Failed';
export const GET_DEPOSITOR_DEPOSIT_SUMMARY_SUCCESS = '[Deposits] Get Depositor Deposit Summary Success';
export const GET_DEPOSITOR_DEPOSIT_SUMMARY_FAILED = '[Deposits] Get Depositor Deposit Summary Failed';
export const CREATE_DEPOSIT_TRANSACTION_SUCCESS = '[Deposits] Create Deposit Transaction Success';
export const CREATE_DEPOSIT_TRANSACTION_FAILED = '[Deposits] Create Deposit Transaction Failed';
export const GET_DEPOSIT_INTEREST_HISTORY_SUCCESS = '[Deposits] Get Deposit Interest History Success';
export const GET_DEPOSIT_INTEREST_HISTORY_FAILED = '[Deposits] Get Deposit Interest History Failed';
export const UPDATE_INTEREST_RATE_SUCCESS = '[Deposits] Update Interest Rate Success';
export const UPDATE_INTEREST_RATE_FAILED = '[Deposits] Update Interest Rate Failed';
export const CLEAR_DEPOSIT_ERRORS = '[Deposits] Clear Errors';
export const RESET_DEPOSIT_SUCCESS = '[Deposits] Reset Success State';

// Action Creators
export function depositsLoadingToggle(status) {
    return {
        type: DEPOSITS_LOADING_TOGGLE,
        payload: status,
    };
}

export function getDepositsAction(params = {}) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getAllDeposits(params);
            dispatch({
                type: GET_DEPOSITS_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITS_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposits'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositByIdAction(id) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositById(id);
            dispatch({
                type: GET_DEPOSIT_BY_ID_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSIT_BY_ID_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposit'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function createDepositAction(depositData, navigate) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.createDeposit(depositData);
            console.log('response', response)
            if(response && response.success === true){
                dispatch({
                    type: CREATE_DEPOSIT_SUCCESS,
                    payload: response
                });
                swal({
                    title: "Success!",
                    text: response.message || "Deposit created successfully",
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    dispatch(resetDepositSuccess());
                    if (navigate) {
                        navigate('/deposits');
                    }
                });
            } else {
                dispatch({
                    type: CREATE_DEPOSIT_FAILED,
                    payload: response.message || 'Failed to create deposit'
                });
                swal({
                    title: "Error!",
                    text: response.message || "Failed to create deposit",
                    icon: "error",
                    buttons: true
                });
            }
        } catch (error) {
            dispatch({
                type: CREATE_DEPOSIT_FAILED,
                payload: error.response?.data?.message || 'Failed to create deposit'
            });
            swal({
                title: "Error!",
                text: error.response?.data?.message || 'Failed to create deposit',
                icon: "error",
                buttons: true
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function updateDepositAction(id, updateData) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.updateDeposit(id, updateData);
            if (response && response.success === true) {
                dispatch({
                    type: UPDATE_DEPOSIT_SUCCESS,
                    payload: response
                });
                swal({
                    title: "Success!",
                    text: response.message || "Deposit updated successfully",
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    dispatch(resetDepositSuccess());
                });
            } else {
                dispatch({
                    type: UPDATE_DEPOSIT_FAILED,
                    payload: response.message || 'Failed to update deposit'
                });
                swal({
                    title: "Error!",
                    text: response.message || "Failed to update deposit",
                    icon: "error",
                    buttons: true
                });
            }
        } catch (error) {
            dispatch({
                type: UPDATE_DEPOSIT_FAILED,
                payload: error.response?.data?.message || 'Failed to update deposit'
            });
            swal({
                title: "Error!",
                text: error.response?.data?.message || 'Failed to update deposit',
                icon: "error",
                buttons: true
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function closeDepositAction(id) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.closeDeposit(id);
            if (response && response.success === true) {
                dispatch({
                    type: CLOSE_DEPOSIT_SUCCESS,
                    payload: response
                });
                swal({
                    title: "Success!",
                    text: response.message || "Deposit closed successfully",
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    dispatch(resetDepositSuccess());
                });
            } else {
                dispatch({
                    type: CLOSE_DEPOSIT_FAILED,
                    payload: response.message || 'Failed to close deposit'
                });
                swal({
                    title: "Error!",
                    text: response.message || "Failed to close deposit",
                    icon: "error",
                    buttons: true
                });
            }
        } catch (error) {
            dispatch({
                type: CLOSE_DEPOSIT_FAILED,
                payload: error.response?.data?.message || 'Failed to close deposit'
            });
            swal({
                title: "Error!",
                text: error.response?.data?.message || 'Failed to close deposit',
                icon: "error",
                buttons: true
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositHistoryAction(id, params = {}) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositHistory(id, params);
            dispatch({
                type: GET_DEPOSIT_HISTORY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSIT_HISTORY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposit history'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositsDropdownAction(branchId) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositsDropdown(branchId);
            dispatch({
                type: GET_DEPOSITS_DROPDOWN_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITS_DROPDOWN_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposits dropdown'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositorDepositSummaryAction(depositorId) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositorDepositSummary(depositorId);
            dispatch({
                type: GET_DEPOSITOR_DEPOSIT_SUMMARY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITOR_DEPOSIT_SUMMARY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposit summary'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function clearDepositErrors() {
    return {
        type: CLEAR_DEPOSIT_ERRORS
    };
}

export function resetDepositSuccess() {
    return {
        type: RESET_DEPOSIT_SUCCESS
    };
}

export function createDepositTransactionAction(depositId, transactionData) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.createDepositTransaction(depositId, transactionData);
            
            if (response && response.success === true) {
                dispatch({
                    type: CREATE_DEPOSIT_TRANSACTION_SUCCESS,
                    payload: response.data
                });
                swal({
                    title: "Success!",
                    text: response.message || "Transaction added successfully",
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    dispatch(resetDepositSuccess());
                    // Refresh deposit history to show the new transaction
                    dispatch(getDepositHistoryAction(depositId));
                });
                return Promise.resolve(response);
            } else {
                dispatch({
                    type: CREATE_DEPOSIT_TRANSACTION_FAILED,
                    payload: response.message || 'Failed to create transaction'
                });
                swal({
                    title: "Error!",
                    text: response.message || "Failed to create transaction",
                    icon: "error",
                    buttons: true
                });
                return Promise.reject(response);
            }
        } catch (error) {
            dispatch({
                type: CREATE_DEPOSIT_TRANSACTION_FAILED,
                payload: error.response?.data?.message || 'Failed to create transaction'
            });
            swal({
                title: "Error!",
                text: error.response?.data?.message || 'Failed to create transaction',
                icon: "error",
                buttons: true
            });
            return Promise.reject(error);
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositInterestHistoryAction(id, params = {}) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositInterestHistory(id, params);
            dispatch({
                type: GET_DEPOSIT_INTEREST_HISTORY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSIT_INTEREST_HISTORY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest history'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function updateInterestRateAction(depositId, interestData) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.updateInterestRate(depositId, interestData);
            
            if (response && response.success === true) {
                dispatch({
                    type: UPDATE_INTEREST_RATE_SUCCESS,
                    payload: response.data
                });
                swal({
                    title: "Success!",
                    text: response.message || "Interest rate updated successfully",
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    dispatch(resetDepositSuccess());
                    // Refresh interest history to show the new rate
                    dispatch(getDepositInterestHistoryAction(depositId));
                });
                return Promise.resolve(response);
            } else {
                dispatch({
                    type: UPDATE_INTEREST_RATE_FAILED,
                    payload: response.message || 'Failed to update interest rate'
                });
                swal({
                    title: "Error!",
                    text: response.message || "Failed to update interest rate",
                    icon: "error",
                    buttons: true
                });
                return Promise.reject(response);
            }
        } catch (error) {
            dispatch({
                type: UPDATE_INTEREST_RATE_FAILED,
                payload: error.response?.data?.message || 'Failed to update interest rate'
            });
            swal({
                title: "Error!",
                text: error.response?.data?.message || 'Failed to update interest rate',
                icon: "error",
                buttons: true
            });
            return Promise.reject(error);
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}
